import React from "react"
export function CheckBoxFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M16 2a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h12zm-1.763 4.433l-6.367 5.51-1.902-2.181-1.131.985 2.394 2.746.079.078a.75.75 0 00.878.069l.099-.073 6.932-6-.982-1.134z"
        fill="currentColor"
        id="prefix__check-box---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
